import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from 'src/app/error.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
// import { ColumnChangeBO } from '../icd10/icd10.model';
 import * as FileSaver from 'file-saver';
import { GetRetuenPayrollBo, PaidBO, UnPaidBo } from './payroll.model';
import { ColumnChangeBO } from '../list/list.model';
@Injectable()
export class PayrollHttpService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }
  savecolumwidth(list: ColumnChangeBO): Observable<any> {
    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<number>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



  GetAllEmployeesDropdown(): Observable<any> {
    let url = "api/Employee/GetAllEmployeesDropdown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  GetAllClientDropDown(): Observable<any> {
    let url = "api/Client/GetAllClientDropDown?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  exportMileageLogs(exportBo: GetRetuenPayrollBo) {
    let url = "api/PrivatePayMileageLog/exportMileageLogs";
    return this.http.post(url, exportBo, { responseType: 'blob' }).subscribe((data) => {
      //   FileSaver.saveAs(data, "PrivatePayMileage.csv")
    }
    )
  }



   UnPaidUpdatePaydate(saveList: UnPaidBo): Observable<any> {
    let url = "api/Payroll/SavePaidPayroll?";
    return this.http.post(url, saveList, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )

  }




  PaidUpdatePayDate(saveList: PaidBO): Observable<any> {
    let url = "api/Payroll/UpdateDateInPaidPayrroll?";
    return this.http.post(url, saveList, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  MovedToUnpaid(saveList: PaidBO): Observable<any> {
    let url = "api/Payroll/MoveToUnpaidPayroll?";
    return this.http.post(url, saveList, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  exportcsv(getBO: GetRetuenPayrollBo, url: string) {
  
    return this.http.post(url, getBO,  { observe: 'response' }).pipe(
      
     map(data => data.body),
     catchError(this.errorService.handleError))
    
   
  }

  // exportcsv(getBO: GetRetuenPayrollBo) {
  //   let url = "api/Payroll/PayorllExport";
  //   return this.http.post(url, getBO, { responseType: 'blob' }).subscribe((data) => {
  //       FileSaver.saveAs(data, "PrivatePayMileage.csv")
  //   }
  //   )
  // }



   //==============================get employee permission==========================================//
   getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }




}
